import { useSelector } from 'react-redux';
import { DialogContentText, List, ListItem, ListItemText } from '@mui/material';

import { dialogPropsSelector } from 'store/entities/ui/slice';
import { Dialog } from 'components/complex';

const id = 'invalid-invites-dialog';

const styles = {
  list: { listStyle: 'disc', pl: 3 },
  listItem: { display: 'list-item' },
  listItemText: { margin: 0 },
};

export const InvalidInvitesDialog = () => {
  const { invalidInvites = [], organisationId } = useSelector(dialogPropsSelector);

  const dialogTitle = organisationId ? 'Adding Users to Organisation' : 'Adding Users';
  const contentText = organisationId
    ? 'The following users have already been invited or added to the Organisation:'
    : 'The following users have already been invited or added:';

  return (
    <Dialog title={dialogTitle} id={id} cancelLabel="OK">
      <DialogContentText id={`${id}-description`} variant="body2" color="text.primary" paragraph>
        {contentText}
      </DialogContentText>

      <List sx={styles.list}>
        {invalidInvites.map((email = '') => (
          <ListItem sx={styles.listItem} key={email} disablePadding disableGutters>
            <ListItemText primaryTypographyProps={{ variant: 'body2' }} primary={email} sx={styles.listItemText} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};
